import LoadQueue = createjs.LoadQueue;
import EventDispatcher = createjs.EventDispatcher;
import { URLRequest } from "./URLRequest";

export class URLLoader {
    public request: URLRequest | null;
    public loadQueue: LoadQueue = new LoadQueue();

    constructor(request: URLRequest | null = null) {
        this.request = request;
    }

    public load(urlRequest: URLRequest): void {
        if (!this.request) {
            throw new Error(`this.request is not set`);
        }

        this.loadQueue.loadFile(this.request.url);
    }

    public close(): void {
        // this.loadQueue.cancel();
        this.loadQueue.close();
    }

    public get dataFormat(): string {
        return "";
    }

    public set dataFormat(value: string) {
        value;
    }

    public get data(): any {
        return "";
    }

    addEventListener(type: string, callback: Function): Function {
        return this.loadQueue.addEventListener(type, callback) as Function;
    }

    removeEventListener(type: string, callback: Function): Function {
        // TODO: @HTML5 - implement this
        return new Function();
    }
}
